/** How many of a KYC's questions are answered, as both apps word it: "2 av 10 besvarade", "Alla 10 besvarade". */
export const kycAnswersCountText = (answered: number, total: number): string =>
  answered >= total ? `Alla ${total} besvarade` : `${answered} av ${total} besvarade`
